import { Typography } from '@mui/material';
import styled from 'styled-components';


export const LabelText = styled(Typography).withConfig<{ wrap?: boolean }>(({ shouldForwardProp: prop => prop !== 'wrap' }))(({ wrap }) => `
font-size: 12px;
line-height: 1.3;
fontWeight: 600;
white-space: ${wrap ? 'wrap' : 'nowrap'};
`);